import { Clazz } from './clazz'
import { School } from './school'
import { Teacher } from './teacher'
import { HomeworkContent } from './homework'
import { CompetitionType } from './competition'
import { StatusUnstartStartedEnded } from './status'
import { HomeworkPlanTemplate } from './homeworkTemplate'

export enum VacationHomeworkType {
  WinterVacation2021 = 'winter_hw_2021',
  SummerVacation2022 = 'activity_summer_2022',
  SpringSemester2022Homework = 'activity_start_term_202202_homework',
  SpringSemester2022Competition = 'activity_start_term_202202_competition',
}

export enum VacationHomeworkPlanItemTopicEnum {
  Exam = 'exam',
  Homework = 'homework',
  Competition = 'competition',
}

export interface IVacationHomeworkConfig {
  name: string
  label: string
  activityName: string
  topics: [boolean, boolean, boolean]
  startDate: Date
  endDate: Date
}

export interface IVacationHomeworkPlan {
  id: string
  title: string
  message: string
  start_date: string
  end_date: string
  classes: Clazz[]
  teacher: Teacher
  status: StatusUnstartStartedEnded
}

export interface IVacationHomeworkPlanDetails extends IVacationHomeworkPlan {
  hw_type: VacationHomeworkType
  schools: School[]
  items: IVacationHomeworkPlanItem[]
}

export interface IVacationHomeworkPlanItem {
  weekno: number
  homework?: {
    title: string
    template_id: string
    is_check_wd5: boolean
    message: string
    biz_items: { id: string; title: string | null }[]
    homework_contents: HomeworkContent[]
  }
  competition?: {
    title: string
    biz_items: { id: string; title: string | null }[]
    take_part_limits: number | null
    competition_type_id: number
  }
  body_exam?: {
    title: string
    body_exam_drill_ids: string[]
  }
}

export interface IVacationHomeworkPlanItemDataItem {
  week: number
  label: string
  plan: {
    exam?: { title: string } | null
    homework?: { title: string; homework_contents: HomeworkContent[]; message: string } | null
    competition?: {
      title: string
      competition_type_id: number
      biz_items: { id: string; title: string | null }[]
    } | null
  }
  startDate: Date
  endDate: Date
  dateRange: string
}

export enum VacationHomeworkPlanTemplateScope {
  Official = 1,
  None = 2,
}

export interface IVacationHomeworkPlanTemplate {
  id: string
  icon: string
  title: string
  subtitle: string
  scope: VacationHomeworkPlanTemplateScope
  grades: number[]
  start_time: string
  end_time: string
}

export interface IVacationHomeworkPlanTemplateDetails extends IVacationHomeworkPlanTemplate {
  items: IVacationHomeworkPlanTemplateDetailsItem[]
}

export interface IVacationHomeworkPlanTemplateDetailsItem {
  weekno: number
  competition_type: CompetitionType
  homework_template: HomeworkPlanTemplate
}

export interface IVacationHomeworkParticipant {
  identify_id: string
  teacher_name: string
  school_name: string
  province: string
  city: string
  district: string
  attend_time: string
}
